<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconExport_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="m19.32 10.025-6.486 6.487a.86.86 0 0 1-1.215 0l-6.487-6.488a.86.86 0 0 1 .99-1.378l4.782 2.377V1.87a1.323 1.323 0 0 1 2.645 0v9.153l4.782-2.376a.859.859 0 0 1 .99 1.378ZM22 18a1 1 0 1 0-2 0v3H4v-3a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-4Z"
        clip-rule="evenodd"
    />
</svg>
